import { LOCALE_ID, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StudentSearchComponent } from './student-search/student-search.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from '../material-module';
// import { NgxMicrosoftBotFrameworkModule, BotService, ComService, BotDirective, BotHelperDirective, StyleSetDirective } from 'ngx-microsoft-bot-framework';
import { GenerateStudentAccessComponent } from '../students/generate-student-access/generate-student-access.component';
import { DynamicConfirmModalComponent } from './dynamic-confirm-modal/dynamic-confirm-modal.component';
import { ErrorModalComponent } from './error-modal/error-modal.component';
import { BubblesComponent } from './thank-you-banner/banners/bubbles/bubbles.component';
import { MoonComponent } from './thank-you-banner/banners/moon/moon.component';
import { MusicComponent } from './thank-you-banner/banners/music/music.component';
import { AirplaneComponent } from './thank-you-banner/banners/airplane/airplane.component';
import { RocketComponent } from './thank-you-banner/banners/rocket/rocket.component';
import { SpaceInvadersComponent } from './thank-you-banner/banners/space-invaders/space-invaders.component';
import { StairwayComponent } from './thank-you-banner/banners/stairway/stairway.component';
import { StarsComponent } from './thank-you-banner/banners/stars/stars.component';
import { ThankYouCardComponent } from './thank-you-banner/banners/thank-you-card/thank-you-card.component';
import { ThumbsUpComponent } from './thank-you-banner/banners/thumbs-up/thumbs-up.component';
import { ThankYouBannerComponent } from './thank-you-banner/thank-you-banner.component';
import { MetalComponent } from './thank-you-banner/banners/metal/metal.component';
import { HoldUpCardsComponent } from './thank-you-banner/banners/hold-up-cards/hold-up-cards.component';
import { DrumsComponent } from './thank-you-banner/banners/drums/drums.component';
import { RainbowComponent } from './thank-you-banner/banners/rainbow/rainbow.component';
import { SprayCanComponent } from './thank-you-banner/banners/spray-can/spray-can.component';
import { LoadingSpinnerComponent } from './loading-spinner/loading-spinner.component';
import { SuccessModalComponent } from './success-modal/success-modal.component';
import { ChatBotComponent } from './chat-bot/chat-bot.component';
import { MAT_DATE_LOCALE } from '@angular/material/core';
import { LatestLearningSectionComponent } from './learning-section/latest-learning-section/latest-learning-section.component';
import { BaseLearningSectionComponent } from './learning-section/base-learning-section/base-learning-section.component';
import { NgxFileDropModule } from 'ngx-file-drop';
import { DataTableComponent } from './data-table/data-table.component';
import { StatusPillComponent } from './data-table/status-pill.component';
import { TablePaginationComponent } from './data-table/table-pagination.component';
import { ColumnCellDirective } from './data-table/table-cell.directive';
import { SessionStatusPillComponent } from './session-status-pill/session-status-pill.component';
import { LoginBrandComponent } from './login-brand/login-brand.component';
import { BrandFilterComponent } from './brand-filter/brand-filter.component';
import { BrandSelectComponent } from './brand-filter/brand-select.component';
import { BrandShortCodePipe } from './brand-filter/brand-short-code.pipe';
import { DatePresetsComponent } from './filter-ux/date-presets.component';
import { FilterClearAllComponent } from './filter-ux/filter-clear-all.component';
import { FeatureSwitchDirective } from './feature-switch/feature-switch.directive';
import { TypeaheadComponent } from './typeahead/typeahead.component';



@NgModule({
    declarations: [
        StudentSearchComponent,
        GenerateStudentAccessComponent,
        DynamicConfirmModalComponent,
        ErrorModalComponent,
        BubblesComponent,
        MoonComponent,
        MusicComponent,
        AirplaneComponent,
        RocketComponent,
        SpaceInvadersComponent,
        StairwayComponent,
        StarsComponent,
        ThankYouCardComponent,
        ThumbsUpComponent,
        ThankYouBannerComponent,
        MetalComponent,
        HoldUpCardsComponent,
        DrumsComponent,
        RainbowComponent,
        SprayCanComponent,
        LoadingSpinnerComponent,
        SuccessModalComponent,
        ChatBotComponent,
        LatestLearningSectionComponent,
        BaseLearningSectionComponent,
        DataTableComponent,
        StatusPillComponent,
        TablePaginationComponent,
        ColumnCellDirective,
        SessionStatusPillComponent,
        LoginBrandComponent,
        BrandFilterComponent,
        BrandShortCodePipe,
        FeatureSwitchDirective
    ],
    imports: [
        FormsModule,
        MaterialModule,
        ReactiveFormsModule,
        CommonModule,
        BrandSelectComponent,
        DatePresetsComponent,
        FilterClearAllComponent,
        TypeaheadComponent
        // NgxMicrosoftBotFrameworkModule
    ],
    exports: [
        StudentSearchComponent,
        GenerateStudentAccessComponent,
        DynamicConfirmModalComponent,
        ErrorModalComponent,
        ThankYouBannerComponent,
        LoadingSpinnerComponent,
        LatestLearningSectionComponent,
        DataTableComponent,
        StatusPillComponent,
        TablePaginationComponent,
        ColumnCellDirective,
        SessionStatusPillComponent,
        LoginBrandComponent,
        BrandFilterComponent,
        BrandShortCodePipe,
        DatePresetsComponent,
        FilterClearAllComponent,
        FeatureSwitchDirective,
        TypeaheadComponent
    ],
    providers: [
        // BotService, 
        // ComService, 
        // BotDirective, 
        // BotHelperDirective, 
        // StyleSetDirective,
      { provide: MAT_DATE_LOCALE, useValue: 'en-GB' },
        { provide: LOCALE_ID, useValue: 'en-GB' },
    ]
})
export class SharedModule { }
